export default __webpack_public_path__ + "0248f6d2d5415b1b62d04c57a3de4f9924ab6676/feae26866cdcf63baa9b2b9cf6eff4ee.png";